import React, { useEffect, useState } from "react";

const Latency = ({ latency, children }) => {
  const [countdown, setCountdown] = useState(latency);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(countdown - 1);
    }, 1000);

    if (countdown <= 0) {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [latency, countdown]);

  return <div>{countdown > 0 ? countdown : children}</div>;
};

export default Latency;
